/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Preview_Commit_HintInputs */

const cs_import_preview_commit_hint = /** @type {(inputs: Import_Preview_Commit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit provede plán výše. Exporty na portály zůstanou vypnuté, dokud je neuvolníte u konkrétních inzerátů.`)
};

const en_import_preview_commit_hint = /** @type {(inputs: Import_Preview_Commit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit applies the plan above. Portal exports stay off until you enable them per listing.`)
};

/**
* | output |
* | --- |
* | "Commit applies the plan above. Portal exports stay off until you enable them per listing." |
*
* @param {Import_Preview_Commit_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_preview_commit_hint = /** @type {((inputs?: Import_Preview_Commit_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Preview_Commit_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_preview_commit_hint(inputs)
	return cs_import_preview_commit_hint(inputs)
});